<template>
	<NuxtLayout>
		<section class="blog__DetailHeader container">
			<h1 v-text="page.title" />
      <time :datetime="page.blog_date">{{ formatDate(page.blog_date, 'PPP') }}</time>
			<div v-if="page.description" class="blog__DetailHeaderLead" v-html="page.description" />
		</section>

		<CMSField v-if="page?.content" :data="page.content" />
	</NuxtLayout>
</template>

<script setup>
	defineProps({
		page: {},
	});

	useHead({
		bodyAttrs: {
			class: 'blogDetail',
		},
	});
</script>

<style lang="scss">
	@import url('@/assets/styles/pages/_blogDetail.scss');
</style>
